import React from 'react';
import ReactDOM from 'react-dom';
// import { createBrowserHistory } from "history";
/* HashRouter */
import { BrowserRouter as Router, Switch } from 'react-router-dom';
/* import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel"; */
import { Provider } from 'unstated';
import indexRoutes from 'routes/index';
import { Provider as AlertProvider } from 'react-alert';
import PrivateRoute from 'nxComponents/PrivateRoute/PrivateRoute';
import AlertTemplate from 'nxComponents/NxAlert/NxAlert';
import 'assets/scss/material-dashboard-pro-react.css';
import AuthContainer from 'containers-state/auth';
import NotificationContainer from 'containers-state/notificationState';
import ChatContainer from 'containers-state/chatState';
import TransferContainer from 'containers-state/transferState';

import { createMuiTheme } from '@material-ui/core/styles';
// import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';

import { ThemeProvider/* , install  */} from '@material-ui/styles';
import shadows from '@material-ui/core/styles/shadows';

import ScrollToTop from './ScrollToTop';
// import { initializeFirebase } from './push-notification';
import * as serviceWorker from './serviceWorker';

// install();

const theme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  shadows: shadows.map(() => 'none')
});

const optionStyle = {
  position: 'top right',
  timeout: 8000,
  transition: 'scale', // other transitions : fade
  containerStyle: {
    zIndex: 1400
  }
};

// AuthContainer is written below
const authContainer = new AuthContainer();
const notificationContainer = new NotificationContainer();
const chatContainer = new ChatContainer();
const transferContainer = new TransferContainer();

// aggregation of state
notificationContainer.bindTransfer(transferContainer);
chatContainer.bindAuth(authContainer);
chatContainer.bindTransfer(transferContainer);

ReactDOM.render(
  <Provider inject={[authContainer, chatContainer, transferContainer, notificationContainer]}>
    <AlertProvider template={AlertTemplate} {...optionStyle}>
      {/* <MapProvider> */}
      <Router basename={process.env.PUBLIC_URL}>
        <ScrollToTop>
          <ThemeProvider theme={theme}>
            <Switch>
              {indexRoutes.map(prop => (
                <PrivateRoute path={prop.path} component={prop.component} key={prop.path} />
              ))}
            </Switch>
          </ThemeProvider>
        </ScrollToTop>
      </Router>
      {/* </MapProvider> */}
    </AlertProvider>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
// initializeFirebase();

// WEBPACK FOOTER //
// ./src/index.js
